<template>
    <div>
        <span v-if="show_voter_count" class="rating-stars">
            <span class="rating-value" :style="'width: ' + percentage + '%'">
                <span class="sr-only">{{ internal_value }} / {{ max_rating }}</span>
            </span>
        </span>
        <span v-if="show_voter_count" aria-hidden="true"><strong>{{ internal_value }}</strong></span>
        <span v-if="show_voter_count" class="rating-count">({{voterCount}} {{ voterCount === 1 ? __('Rating') : __('Ratings') }})</span>
        <span v-if="show_fallback" class="rating-count text-muted">{{ __('No ratings yet') }}</span>
    </div>
</template>

<script>
    import trans from '../mixins/trans';

    export default {

        mixins: [
            trans
        ],

        props: {
            'value': null,
            'voterCount': [String, Number],
            'showVoterCount': Boolean
        },

        data() {
            return {
                step: 0.5,
                max_rating: 5,
                show_voter_count: this.showVoterCount,
                show_fallback: false,
            };
        },

        methods: {
            round(value, decimalPlaces = 1) {
                return value.toFixed(decimalPlaces);
            },

            roundToStep(value) {
                let inv = 1.0 / this.step;
                return Math.round(value * inv) / inv;
            },

            updateDisplaySettings() {
                let hasVotes = this.voterCount >=1;

                this.show_voter_count = hasVotes;
                this.show_fallback = !hasVotes;
            }
        },

        mounted() {
            this.updateDisplaySettings();
        },

        updated() {
            this.updateDisplaySettings();
        },

        computed: {
            internal_value() {
                let result = !isNaN(parseFloat(this.value)) ? parseFloat(this.value) : 0.0;
                return this.round(result);
            },

            percentage() {
                if (this.internal_value > 0.0) {
                    return this.roundToStep(this.internal_value) / this.max_rating * 100;
                }
                return 0.0;
            }
        }

    }
</script>